import { Link } from 'react-router-dom';

interface GetLinkPropsOptions {
    external?: boolean;
}

const COMMON_LINK_PROPS = { textDecoration: 'none', style: { color: 'inherit' } };

export const getLinkProps = (link?: string, options?: GetLinkPropsOptions) => {
    if (!link) {
        return {};
    }

    if (options?.external) {
        return {
            ...COMMON_LINK_PROPS,
            as: 'a' as const,
            href: link,
            target: '_blank',
            rel: 'nofollow noopener',
        };
    }

    return { ...COMMON_LINK_PROPS, as: Link, to: link };
};
